<template>
  <div class="toast" @click.stop v-if="toastData">
    <div class="title">{{ toastData.title }}</div>
    <div class="message" v-html="toastData.message"></div>
    <div v-if="type == 1" class="tips">确认更换专属教练规划师吗？</div>
    <div class="message margin10" v-if="type == 2 && phone"
      >若有任何疑问，可联系店长咨询：<br />{{ phone }}</div
    >
    <div class="btn-list">
      <div
        class="btn-item btn-item-confirm"
        v-if="toastData.showConfirm"
        @click="bindConfirm"
        >{{ toastData.confirmText }}</div
      >
      <div
        class="btn-item"
        v-if="toastData.showCancel"
        v-show="type != 2 || (type == 2 && phone)"
        @click="bindCancel"
        >{{ toastData.cancelText }}</div
      >
    </div>
  </div>
</template>

<script>
const AllToastData = {
  1: {
    title: '更换专属训练规划师',
    message:
      '提交申请后，店长将和您沟通身体情况及后续的训练目标，以确保更换教练后能达成您的目标。',
    confirmText: '确定',
    cancelText: '再想想',
    showConfirm: true,
    showCancel: true
  },
  2: {
    title: '更换专属训练规划师',
    message: `已收到您更换专属训练规划师的需求，<br/>正在为您办理，<span style="color:rgba(255, 34, 112, 1)">预计需要1-2个工作日</span>，<br/>请耐心等待～`,
    confirmText: '好的',
    cancelText: '联系店长',
    showConfirm: true,
    showCancel: true
  },
  3: {
    title: '更换结果不满意',
    message: '对本次更换结果不满意，为保障您的体验，总部将致电回访',
    confirmText: '确认提交',
    cancelText: '取消',
    showConfirm: true,
    showCancel: true
  },
  4: {
    title: '反馈成功',
    message: `已收到不满意反馈，我们非常重视您的体验，客服将在1-2个工作日内与您联系`,
    confirmText: '好的',
    cancelText: '',
    showConfirm: true,
    showCancel: false
  }
}
export default {
  props: {
    type: {
      type: Number,
      default: 1
    },
    phone: {
      type: String | Number,
      default: ''
    }
  },
  components: {},
  data() {
    return {
      toastData: null
    }
  },
  watch: {
    type() {
      this.toastData = AllToastData[this.type]
    }
  },
  created() {
    if (this.type) {
      this.toastData = AllToastData[this.type]
    }
  },
  methods: {
    bindConfirm() {
      this.$emit('confirm')
    },
    bindCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.toast {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 275px;
  background: #ffffff;
  border-radius: 8px;
  padding: 32px 21px 10px;
  box-sizing: border-box;

  .tips {
    margin-top: 10px;
    font-weight: bold;
    font-size: 13px;
    color: rgba(5, 11, 39, 0.8);
    line-height: 20px;
  }
  .margin10 {
    margin-top: 10px;
  }
  .title {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    color: #050b27;
    line-height: 25px;
    margin-bottom: 7px;
  }

  .message {
    font-size: 13px;
    color: rgba(5, 11, 39, 0.8);
    line-height: 20px;
  }

  .btn-list {
    margin-top: 19px;

    .btn-item {
      height: 40px;
      font-size: 12px;
      color: #050b27;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
    }

    .btn-item-confirm {
      background: #ff2270;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
      border-radius: 20px;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
    }

    .btn-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
